__webpack_require__.p = "/reports-move-to-option/referrals-hub/";